module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "page"
    }
  }, [(!_vm.isVisited) ? _c('guide', {
    attrs: {
      "showInteract": !_vm.showInteract
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowLoading) ? _c('loading', {
    ref: "loading",
    attrs: {
      "delay": "3000",
      "liveData": _vm.live
    }
  }) : _vm._e(), _vm._v(" "), _c('header-bar', {
    staticClass: "header",
    attrs: {
      "title": _vm.live.Title,
      "id": "header"
    }
  }), _vm._v(" "), (!_vm.showInteract) ? _c('section', {
    staticClass: "interaction"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'liveInteraction',
        params: {
          liveId: this.$route.params.liveId
        }
      }
    }
  }, [_c('h1', [_vm._v("现场互动")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "first-screen"
    }
  }, [_c('section', {
    staticClass: "act-header"
  }, [(_vm.isFixed) ? _c('div', {
    staticStyle: {
      "min-height": "200px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "act-cover"
  }, [(_vm.live.ViewsEnable) ? _c('div', {
    staticClass: "viewCount"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-view"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.viewCount) + " 人收看过\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.live.LiveEnabled) ? _c('count-down') : _vm._e(), _vm._v(" "), (_vm.live.BannerExternalVideoUrl && !_vm.isFixed) ? _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.live.BannerExternalVideoUrl
    }
  }, [_vm._v(_vm._s(_vm.live.BannerExternalName ? _vm.live.BannerExternalName : '查看直播'))]) : _vm._e(), _vm._v(" "), (_vm.live.LiveEnabled) ? _c('div', {
    class: {
      fixVideo: _vm.isFixed && !_vm.hideAll
    }
  }, [(_vm.isFixed) ? _c('div', {
    staticClass: "close-video",
    on: {
      "click": _vm.closeVideo
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('video-player', {
    staticClass: "vjs-custom-skin",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true
    },
    on: {
      "ready": _vm.playerReadied
    }
  })], 1) : (_vm.live.BannerVideo) ? _c('div', {
    class: {
      fixVideo: _vm.isFixed && !_vm.hideAll
    },
    on: {
      "click": _vm.closeVideo
    }
  }, [(_vm.isFixed) ? _c('div', {
    staticClass: "close-video"
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "options": _vm.player2Options,
      "playsinline": true
    }
  })], 1) : _c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.live.Banner,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "act-info"
  }, [_c('p', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shizhongfill"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.live.BeginAt.replace(/T/, ' ')) + " 至 " + _vm._s(_vm.live.EndAt.replace(/T/, ' ')) + "\n        ")]), _vm._v(" "), _c('p', [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-zuobiaofill"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.live.Address) + "\n        ")])])]), _vm._v(" "), _c('yp-title', {
    attrs: {
      "text": _vm.live.SponsorTitle ? _vm.live.SponsorTitle : '相关品牌'
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "list": _vm.live.Sponsors
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "act-desc-panel",
    on: {
      "click": _vm.showLiveDesc
    }
  }, [_c('yp-title', {
    attrs: {
      "text": _vm.live.DescriptionTitle ? _vm.live.DescriptionTitle : '活动详情',
      "subTitle": "查看详情"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "act-description"
  }, [_vm._v("\n        " + _vm._s(_vm.live.Description) + "\n      ")])], 1), _vm._v(" "), _c('popup', {
    attrs: {
      "position": "bottom",
      "max-height": "50%"
    },
    model: {
      value: (_vm.showDetail),
      callback: function($$v) {
        _vm.showDetail = $$v
      },
      expression: "showDetail"
    }
  }, [_c('section', {
    staticClass: "live-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.description(_vm.live.Description))
    }
  })]), _vm._v(" "), (!_vm.showOrder && !_vm.hideAll) ? _c('tips', {
    staticClass: "tips",
    attrs: {
      "text": "上滑观看直播",
      "icon": "up"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showOrder) ? _c('div', {
    staticClass: "order",
    on: {
      "click": _vm.order
    }
  }, [_vm._v("立即报名")]) : _vm._e(), _vm._v(" "), (!_vm.showOrder) ? _c('section', {
    attrs: {
      "id": "second-screen"
    }
  }, [_c('yp-title', {
    staticClass: "list-title",
    attrs: {
      "text": "图片直播",
      "id": "pic_live"
    }
  }), _vm._v(" "), (_vm.showSticky) ? _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e5e5e5"
    },
    attrs: {
      "id": "sticky-box"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated-4 fadeInDown",
      "leave-active-class": "animated-4 fadeOutUp"
    }
  }, [(_vm.message_pic > 0) ? _c('div', {
    staticClass: "fresh-tip",
    on: {
      "click": _vm.fresh_pic
    }
  }, [_vm._v("\n          " + _vm._s(_vm.message_pic) + " 张新图片，点击刷新\n          "), _c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shuaxin"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow-x": "scroll",
      "overflow-y": "hidden",
      "-webkit-overflow-scrolling": "touch"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('tab', {
    attrs: {
      "bar-active-color": "#ff9a00",
      "custom-bar-width": "120px",
      "line-width": 5,
      "id": "sticky-bar"
    },
    model: {
      value: (_vm.tab_index),
      callback: function($$v) {
        _vm.tab_index = $$v
      },
      expression: "tab_index"
    }
  }, [_c('tab-item', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.fetchData('all')
      }
    }
  }, [_vm._v("全部(" + _vm._s(_vm.picCount) + ")")]), _vm._v(" "), _vm._l((_vm.category), function(item, index) {
    return _c('tab-item', {
      key: index,
      on: {
        "on-item-click": function($event) {
          _vm.fetchData(item.Id)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-copy"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated-4 fadeInDown",
      "leave-active-class": "animated-4 fadeOutUp"
    }
  }, [_c('infinite-scroller', {
    ref: "infinite_scroller",
    attrs: {
      "photos": _vm.photoList,
      "isLoad": _vm.isLoad
    },
    on: {
      "cancelShot": _vm.cancelShot,
      "startShot": _vm.startShot,
      "loadMore": _vm.loadMore,
      "showPre": _vm.show
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.previewerList,
      "options": _vm.options
    },
    on: {
      "loadMore": _vm.loadMore
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPass) ? _c('pass-view', {
    attrs: {
      "id": _vm.live.Id,
      "pass": _vm.live.EncryptPassword
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.live.SubscribeDisabled && !_vm.hideAll) ? _c('ad-bar') : _vm._e(), _vm._v(" "), (_vm.live.JigsawEnabled) ? _c('x-shot', {
    ref: "x_shot",
    attrs: {
      "fn_close": _vm.shotClose,
      "url": _vm.locationUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.FaceEnabled && !_vm.hideAll) ? _c('face-recog') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.LargePictureSeparatedEnabled && !_vm.hideAll) ? _c('div', {
    staticClass: "hotview-button",
    on: {
      "click": _vm.goHotView
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/hotviews@2x.png",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 500,
        leave: 800
      },
      "enter-active-class": "animated bounceInRight",
      "leave-active-class": "animated bounceOutRight"
    }
  }, [(_vm.live.JigsawEnabled && !_vm.hideAll) ? _c('div', {
    staticClass: "shot-button",
    on: {
      "click": _vm.choseShot
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.aiyaopai.com/puzzle@2x.png",
      "alt": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('wechat-share', {
    ref: "wechat",
    attrs: {
      "title": _vm.live.Title,
      "subTitle": _vm.live.SubTitle,
      "shareImg": _vm.live.ShareLogo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb51e45"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/live/LiveDetail.vue
// module id = 510
// module chunks = 1